import React from "react";
import { Link } from "react-router-dom";

function Faq_header(){

    return(
        <div className="faq-header">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <h1>سوالات متداول</h1>
                        <div className="breadcrumbs">
                            <Link to="/">صفحه اصلی</Link>
                            <i className="fas fa-angle-left"></i>
                            <span className="current-page">سوالات متداول</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

}

export default Faq_header;